export default __webpack_public_path__ + "static/gradient-bottom-8a4de59dfa701be9502a4ccc3a3cee64.png";